import Modal from '../../../ui-new/Modal/Modal';
import styles from './ApproveToBillModal.module.css';
import { ReactComponent as InvoiceIcon } from '../../../assets/DocumentText.svg';
import Button from '../../../ui-new/Button/Button';
import { useState } from 'react';

type Props = {
    isOpen: boolean;
    onClose: () => void;
    onApprove: () => Promise<void>;
    onCreateInvoice: () => void;
};

const ApproveToBillModal = ({ isOpen, onClose, onApprove, onCreateInvoice }: Props) => {
    const [isApprovalLoading, setIsApprovalLoading] = useState(false);

    return (
        <Modal isOpen={isOpen} onClose={onClose} className={styles.container} closeOnEscape closeOnOverlayClick>
            <div className={styles.modalBody}>
                <InvoiceIcon className={styles.icon} />
                <div>Do you want to create an invoice?</div>
            </div>

            <Modal.Actions>
                <Button
                    appearance="ghost"
                    onClick={async () => {
                        setIsApprovalLoading(true);
                        await onApprove();
                        setIsApprovalLoading(false);
                    }}
                    isLoading={isApprovalLoading}
                    disabled={isApprovalLoading}
                >
                    Approve without invoice
                </Button>
                <Button appearance="primary" onClick={onCreateInvoice} disabled={isApprovalLoading}>
                    Yes, create
                </Button>
            </Modal.Actions>
        </Modal>
    );
};

export default ApproveToBillModal;
